export enum RutterJobStatus {
    Prequeued = 'prequeued',
    Success = 'success',
    Failed = 'failure',
    InProgress = 'in_progress',
    Pending = 'pending',
}
